/** @jsxImportSource @emotion/react */
import * as React from 'react';
import * as R from 'ramda';
import { css, keyframes, SerializedStyles } from '@emotion/react';
import { DARK_GREY } from '../../../styles/colors';
import { BLADE_ANGLE, DEFAULT_BLADE_COUNT } from './config';


const fadeAnimation = keyframes`
  0%, 39%, 100% { opacity: 0; }
  40% { opacity: 1; }
`;

const circle = css`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  
  &::before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: ${DARK_GREY};
    border-radius: 100%;
    animation: ${fadeAnimation} 1.2s infinite ease-in-out both;
  }
`;

/**
 * Loader: a component that shows a spinning loading indicator
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export const Loader: React.FC<{ rootCss?: SerializedStyles }> = props => (
  <div css={css`
         margin: auto;
         width: 100px;
         height: 100px;
         position: relative;
         ${props.rootCss};
       `}>
    <div css={circle}/>
    {
      R.range(1, DEFAULT_BLADE_COUNT).map(
        i => <div key={'loader-' + i}
                  css={css`
                    ${circle};
                    transform: rotate(${BLADE_ANGLE * i}deg);

                    &::before {
                      animation-delay: ${-1.2 + i / 10}s;
                    }
                  `}/>,
      )
    }
  </div>
);
